import React from 'react';
import { Link } from 'react-router-dom'
import './card-style.css'


function EventCategoryCard(props) {
    let { id, category, count, level } = props.eventcategory;



    return (
        <div className='card text-center shadow '>

            <div className='overflow'>
                {<Link to={{ pathname: "/" + props.target, state: { category: category, level: level, premiumlevel: props.premiumlevel } }}>
                    <img src={props.imgsrc} alt='QuizWizard' className='card-img-top' width="200" height="250" />
                </Link>}
                <div className='card-body text-dark'>
                    <h4 className='card-text'>{category}</h4>
                    <h4 className='card-text'>{count} Events</h4>
                </div>
            </div>
        </div>

    );
}






export default EventCategoryCard;
